const storeSuggestion = 6

export const fetchStoreSuggestion = identifier => ({
  type: 'FETCH_STORE_SUGGESTIONS',
  payload: {
    client: 'cloudloyalty',
    request: {
      url: `/v2/showcases/${storeSuggestion}?identifier=${identifier}`
    }
  }
})



// WEBPACK FOOTER //
// ./src/features/Suggestion/StoreSuggestion/actions.js